import http from '@/utils/http'

export const setStudentSubject = (params) => http.put('/marking-platform/students/level_exam', params) // 设置学生选科信息
export const exportStuExam = (params) => http.post('/marking-platform/students/level_exam/file/get', params) // 导出学生选课信息接口

export const queryClassInfo = (params) => http.get('/marking-platform/school-class/query_class_role', params)
export const addClassInfo = (params) => http.post('/marking-user/user/school/add_class_role', params)
export const updateUserStatus = params => http.put(`/marking-platform/teachers/${params.id}/status/${params.status}`, {}) // 更新状态
// 获取学校教师列表
export const getSchoolTeacherListBySubject = (params) => http.get('/marking-user/user/teacher/query/subject/teacher', params)
export const deleteTeachClass = (params) => http.get('/marking-user/user/teachclass/del_teach_class', params) // 删除教学班级
export const getTeachClassList2 = (params) => http.post('/marking-platform/school-class/course/teach-class', params) // 获取教学班级列表

// 获取sum学期
export const getTerm = schoolId => http.get('/marking-platform/school/' + schoolId + '/academic-year/term', {})
export const phaseGetSubject = (params) => http.post('/marking-user/user/ability/get_subject', params)// 根据学段获取学科
export const getAbility = (params) => http.post('/marking-user/user/ability/get_list', params)// 根据学科获取能力
export const addAbility = (params) => http.post('/marking-user/user/ability/insert', params)// 添加能力
export const delAbility = (params) => http.post('/marking-user/user/ability/delete', params)// 删除能力

// 角色管理
export const getRoleList = schoolId => http.get(`/marking-platform/roles/schools/${schoolId}/roles`, { scope: 0 })

// 角色管理 - 菜单权限
export const getPermList = () => http.post('/marking-platform/permissions/templates-type/1', [])// 获取已有菜单权限项
export const updatePerm = (params) => http.put(`/marking-platform/permissions/schools/${params.schoolId}/roles/${params.roleId}`, params.perms)// 更新角色权限
export const getPerm = (params) => http.get(`/marking-platform/permissions/schools/${params.schoolId}/roles/${params.roleId}`, {})// 获取角色权限

export const getTeachersWithRole = (params) => http.post('/marking-platform/teachers/search', params) // 查询老师以及权限

